import React from 'react';

export const DMBlockFilterSearchPreview = () => {
  return (
    <div className='article__grid'>
      <div className='article__bodytext preview__blockmessage'>
        <p>DM filter modul vises kun i sluttportal.</p>
      </div>
    </div>
  );
};
